import React, {
  createContext, useEffect, useMemo, useState,
} from 'react'
import { Navigate, Outlet, useOutletContext } from 'react-router-dom'
import translatorStorage from 'services/translatorStorage'

export const IndentifiedTranslatorContext = createContext({
  translator: {},
  setTranslator: () => {},
})

const IdentifiedTranslatorProvider = ({ children }) => {
  const setDisplayedUser = useOutletContext()

  const [translator, setTranslator] = useState(
    translatorStorage.getTranslator(),
  )

  useEffect(() => {
    setDisplayedUser(translator)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setTranslatorHandler = (value) => {
    translatorStorage.saveTranslator(value)
    setTranslator(value)
    setDisplayedUser(value)
  }

  const contextValue = useMemo(
    () => ({ translator, setTranslator: setTranslatorHandler }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [translator],
  )

  return (
    <IndentifiedTranslatorContext.Provider value={contextValue}>
      <Outlet />
    </IndentifiedTranslatorContext.Provider>
  )
}

export default IdentifiedTranslatorProvider
